import { defineDirective, doclib, IDocumentLibraryService, ImportDocument, IOmniaShell, isString, isUndefinedOrNull } from "../../omnia"

export class PicturePopup {

    static create() {
        return defineDirective(PicturePopup, "app/datalayers/map/pictures/popup.html")
    }

    public picture: ImportDocument
    private popupOpened?: boolean = false

    static $inject = ["$scope", "OmniaDocumentLibraryService", "OmniaShell"]

    constructor($scope: ng.IScope, private svc: IDocumentLibraryService, private shell: IOmniaShell) {

        const picture = this.picture = $scope.$parent["picture"]

        $scope.$parent["togglePopup"] = (open?: boolean) => {
            this.togglePopup(open)
            $scope.$applyAsync()
        }


        if (picture && picture.UploadDate && isString(picture.UploadDate)) {
            omnia.setDates([picture], ["UploadDate", "ExifDate"], false);
        }

    }

    togglePopup(open?: boolean) {
        open = (isUndefinedOrNull(open) ? !this.popupOpened : null) || open
        this.popupOpened = open
    }

    getImgPath(): string {
        if (this.picture) {
            return this.svc.getImgPath(this.picture, "thumbnail");
        }
    }

    showDialog() {

        this.shell.showComponentAsDialog(doclib.ReactDocumentPropertiesPopup,
            { document: this.picture, manageLibrary: false },
            { size: 'lg' });

    }
}

